var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox integral-goods-manage-page" },
    [
      _c(
        "el-card",
        {
          staticClass: "box-card goods-manage-card",
          attrs: { shadow: "never" },
        },
        [
          _c(
            "div",
            {
              staticClass: "goods-manage-page-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "back-btn",
                  attrs: { type: "text", icon: "el-icon-arrow-left" },
                  on: { click: _vm.goBack },
                },
                [_vm._v("返回")]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "header-title" }, [
                _vm._v(_vm._s(_vm.displayTitle)),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("goods-manage-content", {
            attrs: {
              "activity-id": _vm.activityId,
              "activity-type": _vm.activityType,
              readonly: _vm.readonly,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }